"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceType = exports.HttpStatusCode = exports.CampaignStrategyEnum = exports.PlatformTypeEnum = exports.ChannelTypeEnum = exports.DedupIdentity = exports.CampaignStatusEnum = void 0;
// interface for campaigns status
var CampaignStatusEnum;
(function (CampaignStatusEnum) {
    CampaignStatusEnum["ACTIVE"] = "ACTIVE";
    CampaignStatusEnum["DRAFT"] = "DRAFT";
    CampaignStatusEnum["PAST"] = "PAST";
    CampaignStatusEnum["PENDING"] = "PENDING";
})(CampaignStatusEnum = exports.CampaignStatusEnum || (exports.CampaignStatusEnum = {}));
/**
 * Enum representing different identity types used for deduplication logic.
 * These identities help identify and filter out duplicate messages based on the selected key.
*/
var DedupIdentity;
(function (DedupIdentity) {
    /** Deduplicate based on a unique session or authentication token */
    DedupIdentity["TOKEN"] = "token";
    /** Deduplicate based on email address (used in email campaigns) */
    DedupIdentity["EMAIL"] = "email";
    /** Deduplicate based on phone number (used in SMS or voice campaigns) */
    DedupIdentity["PHONE"] = "phone";
    /** Deduplicate based on device ID (typically for app push notifications or device-level targeting) */
    DedupIdentity["DEVICE_ID"] = "did";
    /** Deduplicate based on user ID (internal platform identifier for a user) */
    DedupIdentity["USER_ID"] = "userid";
})(DedupIdentity = exports.DedupIdentity || (exports.DedupIdentity = {}));
// Enum for different channel types
var ChannelTypeEnum;
(function (ChannelTypeEnum) {
    ChannelTypeEnum["EMAIL"] = "email";
    ChannelTypeEnum["SMS"] = "sms";
    ChannelTypeEnum["CHAT"] = "chat";
    ChannelTypeEnum["PUSH"] = "push";
    ChannelTypeEnum["ADS"] = "ads";
    ChannelTypeEnum["APPINBOX"] = "appinbox";
    ChannelTypeEnum["WHATSAPP"] = "whatsapp";
    ChannelTypeEnum["WEBPUSH"] = "webpush";
    ChannelTypeEnum["GENERIC"] = "generic";
    ChannelTypeEnum["CNS"] = "cns";
    ChannelTypeEnum["INAPP"] = "inapp";
    ChannelTypeEnum["GETAPP"] = "getApp";
    ChannelTypeEnum["NATIVE"] = "Native";
    ChannelTypeEnum["WEBPOPUP"] = "webpopup";
})(ChannelTypeEnum = exports.ChannelTypeEnum || (exports.ChannelTypeEnum = {}));
// Enum for different platform types
var PlatformTypeEnum;
(function (PlatformTypeEnum) {
    PlatformTypeEnum["ANDROID"] = "Android";
    PlatformTypeEnum["IOS"] = "iOS";
    PlatformTypeEnum["WEB"] = "Web";
})(PlatformTypeEnum = exports.PlatformTypeEnum || (exports.PlatformTypeEnum = {}));
// Enum for different campaign Strategy
var CampaignStrategyEnum;
(function (CampaignStrategyEnum) {
    CampaignStrategyEnum["AB"] = "ab";
})(CampaignStrategyEnum = exports.CampaignStrategyEnum || (exports.CampaignStrategyEnum = {}));
// Enum for HTTP status codes
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
})(HttpStatusCode = exports.HttpStatusCode || (exports.HttpStatusCode = {}));
/**
 * Audience Type Enum for user and system
*/
var AudienceType;
(function (AudienceType) {
    AudienceType["USER"] = "user";
    AudienceType["SYSTEM"] = "system";
})(AudienceType = exports.AudienceType || (exports.AudienceType = {}));
